// Navigation service to handle routing from stores and utilities
class NavigationService {
  private navigate: ((to: string, options?: any) => void) | null = null;

  // Set the navigate function (called from a React component)
  setNavigate(navigateFunction: (to: string, options?: any) => void) {
    this.navigate = navigateFunction;
  }

  // Navigate to a route
  navigateTo(to: string, options?: any) {
    if (this.navigate) {
      console.log('🔄 NavigationService: Navigating to', to, options);
      this.navigate(to, options);
    } else {
      console.warn('🔄 NavigationService: Navigate function not set, falling back to window.location');
      // Fallback to window.location if navigate function is not available
      if (options?.replace) {
        window.location.replace(to);
      } else {
        window.location.href = to;
      }
    }
  }

  // Check if navigation is available
  isAvailable(): boolean {
    return this.navigate !== null;
  }
}

// Export singleton instance
export const navigationService = new NavigationService(); 